import React, { memo } from "react";
import styles from "./styles.module.css";
const CollapseItem = memo(
  ({ item, isActive, onToggle, itemStyles, headerStyles, contentStyles }) => {
    const { key, header, content } = item;

    return (
      <div
        className={`${styles["collapse-item"]} ${itemStyles || ""}`}
        data-key={key}
      >
        <div
          className={`${styles["collapse-header"]} ${headerStyles || ""}`}
          onClick={() => onToggle(key)}
          aria-expanded={isActive}
          aria-controls={`content-${key}`}
          role="button"
          tabIndex={0}
        >
          {header}
          <img
            src="/ui/images/Truman-UI-accordion-arrow.svg"
            alt="collapse"
            className={`${styles["expandable-image"]} ${
              isActive ? styles["img-expand"] : styles["img-collapse"]
            }`}
          />
        </div>
        <div
          id={`content-${key}`}
          className={`${styles["collapse-content"]} ${
            isActive ? styles["open"] : ""
          } ${contentStyles || ""}`}
          aria-hidden={!isActive}
        >
          {content}
        </div>
      </div>
    );
  }
);

export default CollapseItem;
